import { Card } from '@mantine/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import styles from './styles.scoped.css';

const SortableCard = ({ id, item }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: 'relative',
    zIndex: isDragging ? 1 : 0,
  };

  const renderContent = (value) => {
    const regex = /(<([^>]+)>)/gi;
    const newString = value.type === 'text' ? value.content.replace(regex, ' ') : '-';
    return (
      value.type === 'text-image' ? (
        <span>{value.description}</span>
      ) : (
        <span>{newString}</span>
      )
    );
  };

  const renderThumbnail = (value) => {
    return value.thumbnail ? (
      <div className={styles.thumbnailContainer}>
        <img alt="thumbnail" src={value.thumbnail} />
      </div>
    ) : (
      <div className={styles.emptyThumbnail}>-</div>
    );
  };

  return (
    <Card
      className={styles.sortableCard}
      padding="6px 8px"
      ref={setNodeRef}
      style={style}
    >
      <div className={styles.cardInner}>
        <div className={styles.dragHandle} {...attributes} {...listeners}>
          <svg fill="currentColor" height="20" viewBox="0 0 20 20" width="20">
            <path d="M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z" />
          </svg>
        </div>
        <div className={styles.orderSection}>
          <div className={styles['order-number']}>
            {item.orderNumber || '1'}
          </div>
          {/* {renderStatus(item.isActive !== undefined ? item.isActive : true)} */}
        </div>
        <div className={styles.mainContent}>
          <div className={styles.textContent}>
            <div className={styles.title}>{item.title}</div>
            <div className={styles.description}>
              {renderContent(item)}
            </div>
            <div className={styles.period}>
              <span className={styles.labelText}>Periode: {`${dayjs(item.startDate).format('DD MMM YYYY')} - ${dayjs(item.endDate).format('DD MMM YYYY')}`} </span>

            </div>
          </div>
          <div className={styles.imageSection}>
            {renderThumbnail(item)}
          </div>
        </div>
      </div>
    </Card>
  );
};

SortableCard.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  item: PropTypes.shape({
    title: PropTypes.string,
    isActive: PropTypes.bool,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    type: PropTypes.string,
    content: PropTypes.string,
    description: PropTypes.string,
    thumbnail: PropTypes.string,
    orderNumber: PropTypes.number
  }).isRequired
};

export default SortableCard;
